import { useState } from 'react';

export default function Testimonios() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonios = [
    {
      rating: 5.0,
      texto: 'El CDE MIPYME transformó completamente mi negocio. Gracias a su asesoría personalizada, logré formalizar mi empresa y aumentar mis ventas en un 60% en solo seis meses. El equipo es profesional, comprometido y realmente se preocupa por el éxito de los emprendedores.',
      nombre: 'María Elena Rodríguez',
      empresa: 'Café Artesanal La Esperanza',
      avatar: 'https://public.readdy.ai/ai/img_res/5f4ebe027356ae04e6b89df518efe7af.jpg'
    },
    {
      rating: 5.0,
      texto: 'Las capacitaciones del CDE me dieron las herramientas que necesitaba para llevar mi emprendimiento al siguiente nivel. Aprendí sobre gestión financiera, marketing digital y cómo estructurar un plan de negocio sólido. Hoy mi empresa es más competitiva y rentable.',
      nombre: 'Carlos Mejía',
      empresa: 'Textiles y Confecciones del Valle',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20honduran%20businessman%20entrepreneur%20smiling%20confident%20simple%20neutral%20background%20business%20owner%20headshot&width=200&height=200&seq=testimonio-carlos-001&orientation=squarish'
    },
    {
      rating: 5.0,
      texto: 'Gracias al programa de acceso a mercados del CDE MIPYME, pude conectar con nuevos clientes y distribuidores. El acompañamiento fue excepcional y me ayudaron a posicionar mis productos en tiendas importantes de San Pedro Sula. Totalmente recomendado.',
      nombre: 'Ana Lucía Flores',
      empresa: 'Productos Naturales Vida Sana',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20honduran%20businesswoman%20entrepreneur%20smiling%20confident%20simple%20neutral%20background%20business%20owner%20headshot&width=200&height=200&seq=testimonio-ana-001&orientation=squarish'
    }
  ];

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonios.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonios.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="py-32 bg-[#FAF9F7]">
      <div className="max-w-5xl mx-auto px-8 lg:px-16">
        <h2 className="text-4xl lg:text-5xl font-bold text-center text-gray-900 mb-20" style={{ fontFamily: 'Georgia, serif' }}>
          Lo Que Dicen Nuestros Empresarios
        </h2>

        <div className="relative">
          <div className="absolute top-0 left-0">
            <div className="inline-flex items-center space-x-2 bg-gray-900 text-white px-4 py-2 rounded-full">
              <i className="ri-star-fill text-yellow-400"></i>
              <span className="font-bold">{testimonios[currentIndex].rating}</span>
            </div>
          </div>

          <div className="pt-16">
            <p className="text-2xl text-gray-800 leading-relaxed mb-12" style={{ fontFamily: 'Georgia, serif' }}>
              "{testimonios[currentIndex].texto}"
            </p>

            <div className="flex items-center space-x-4">
              <img
                src={testimonios[currentIndex].avatar}
                alt={testimonios[currentIndex].nombre}
                className="w-16 h-16 rounded-full object-cover object-top"
              />
              <div>
                <div className="font-bold text-gray-900 text-lg">
                  {testimonios[currentIndex].nombre}
                </div>
                <div className="text-gray-600 text-sm">
                  {testimonios[currentIndex].empresa}
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center space-x-3 mt-12 justify-end">
            <button
              onClick={handlePrev}
              className="w-12 h-12 border-2 border-gray-300 rounded-lg flex items-center justify-center hover:border-gray-400 transition-colors"
            >
              <i className="ri-arrow-left-line text-gray-700"></i>
            </button>
            <button
              onClick={handleNext}
              className="w-12 h-12 bg-gray-900 rounded-lg flex items-center justify-center hover:bg-gray-800 transition-colors"
            >
              <i className="ri-arrow-right-line text-white"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
